import React from "react";
import { View } from "react-native";
import Text from "../../components_v2/TextFont";
interface Props {
  children: any;
  title?: string;
  subTitle?: string;
}

const ConditionEventLayout = ({ children, title, subTitle }: Props) => {
  return (
    <View style={{ flex: 1, height: "100%" }}>
      {/* === Title === */}
      {title && (
        <Text
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 20,
            marginBottom: 15,
          }}
        >
          {title}
        </Text>
      )}
      {/* === subTitle === */}
      {subTitle && (
        <Text style={{ marginHorizontal: 10, fontSize: 12 }}>{subTitle}</Text>
      )}
      {/* === Body === */}
      {children}
    </View>
  );
};

export default ConditionEventLayout;
